import React from 'react'

export default function IframeEditorModule({value, onDataChanged, props}) {
    return <div>
        <hr/>
        <h5 className="hotspot-setting-header">IFrame</h5>

        <h5 className="hotspot-setting-header">IFrame URL</h5>
        <div className="hotspot-setting-info">
            Url used as source for the iframe.
        </div>
        <div className="form-group">
            <input
              className="form-control"
              type="text"
              placeholder="https://your.link/..."
              value={value?.iframe_url}
              onChange={(event) => {
                  onDataChanged({
                      ...value,
                      iframe_url: event.target.value
                  })
              }}
            />
        </div>
    </div>
}
